module.exports = __webpack_public_path__ + "static/media/hk.bb078da1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/hk.svg
// module id = 1056
// module chunks = 0